import React from "react";
import { Alert } from "@mui/material";
import AppModal from "../common/AppModal";
import CreateOrUpdateRoleForm from "../../forms/CreateOrUpdateRoleForm";

const UpdateRoleModal = ({ open, onClose, role, loading, error }) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title={`Update Role: ${role.name}`}
      width="lg"
      loading={loading}
    >
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <CreateOrUpdateRoleForm isEditing={true} role={role} loading={loading} />
    </AppModal>
  );
};

export default UpdateRoleModal;
